import { AccountActionsTypes } from "../types";

export function dismissMessage() {
  return {
    type: AccountActionsTypes.DISMISS_MESSAGE
  };
}
